import { Logo } from "@/components/AppHeader";
import { Input } from "@/components/ui/input";

export const AuthField = ({ label, ...props }) => (
  <label className="block">
    <span className="eyebrow mb-2 block">{label}</span>
    <Input {...props} className="h-12 border-slate-800 bg-[#131927] text-base focus-visible:ring-[#FF2D78]" />
  </label>
);

export const AuthShell = ({ eyebrow, title, children }) => (
  <div className="grain relative grid min-h-screen bg-[#0B0F19] lg:grid-cols-2">
    <div className="relative hidden overflow-hidden lg:block">
      <img src="https://images.unsplash.com/photo-1686753767461-35673e3dfa77?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200" alt="Athlete"
        className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0F19]/30 to-[#0B0F19]" />
      <div className="absolute bottom-12 left-12 max-w-md">
        <p className="font-display text-5xl font-black uppercase leading-[0.9] tracking-tight">Members<br />by invitation.</p>
      </div>
    </div>
    <div className="relative z-10 flex flex-col px-6 py-8 sm:px-12">
      <Logo />
      <div className="rise mx-auto my-auto w-full max-w-md py-12">
        <p className="eyebrow !text-[#FF2D78]">{eyebrow}</p>
        <h1 className="mb-8 mt-3 font-display text-4xl font-black uppercase tracking-tight sm:text-5xl">{title}</h1>
        {children}
      </div>
    </div>
  </div>
);

export const SubmitButton = ({ busy, children, testId }) => (
  <button type="submit" disabled={busy} data-testid={testId}
    className="flex h-12 w-full items-center justify-center gap-2 rounded-full bg-[#FF2D78] font-semibold text-white transition-colors duration-200 hover:bg-[#E01F66] disabled:opacity-60">
    {busy && <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />} {children}
  </button>
);

export const ErrorNote = ({ text }) =>
  text ? <p data-testid="auth-error-message" className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">{text}</p> : null;
